module.exports = __webpack_public_path__ + "img/common-file-cash.870affde.svg";